module.exports = __webpack_public_path__ + "static/media/logo.c3e3deb7.png";